// extracted by mini-css-extract-plugin
module.exports = {"colors":"'../../variables.css'","visualDetails":"dRDN4wwl07z-FZ10zcM-o","container":"_682uFNPLeBZb64En0Imeg","actionButtons":"x74AT-bsrEYziWPP4TSZ"};